import { useEffect, useState } from 'react';

import { useClassStudentSearchDropdown } from '@/features/class-module-management/hooks/useClassStudentSearchDropdown';
import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';
import type { LookupAutocompleteProps } from './CompanyAutocomplete';

/** Autocomplete de turma / "Vincular turma" (lookup `shared/class-students`). */
export function ClassStudentAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  label,
  placeholder,
  hasError,
}: LookupAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useClassStudentSearchDropdown(search);

  // Rótulo exibido no campo quando há seleção (o ADS mostra o `selectedItem.label`).
  // Durante a busca sem seleção, o texto digitado é exibido pelo próprio input.
  // Sincroniza quando o pai fornece o rótulo após a montagem (ex.: edição, cujo
  // draft é populado depois que o autocomplete já montou).
  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      hasError={hasError ?? false}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
